export default __webpack_public_path__ + "static/media/6.9c803e9d.jpg";